// Build-time feature flags (CRA reads REACT_APP_* env vars at build time).
//
// DRIVE_IMPORT_ENABLED — gates the admin-only Google Drive import button.
// Drive import uses the restricted `drive.readonly` OAuth scope. Exposing it
// to customers in production would force Google's sensitive/restricted-scope
// verification (CASA security assessment). It's hidden by default so the app
// stays in the no-verification lane. The backend integration is left intact;
// set REACT_APP_ENABLE_DRIVE_IMPORT=true to re-enable the UI.
export const DRIVE_IMPORT_ENABLED =
  process.env.REACT_APP_ENABLE_DRIVE_IMPORT === 'true';
